/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import { DatastudioReportApiProps, DatastudioReportsApiProps } from './types';
import datastudioReport from './datastudioReport';

const datastudioReportTag = baseApi.enhanceEndpoints({
  addTagTypes: [datastudioReport.tagType],
});
const datastudioReportApi = datastudioReportTag.injectEndpoints({
  endpoints: (builder) => ({
    getDatastudioReports: builder.query<DatastudioReportsApiProps, void>(
      datastudioReport.getEntities(),
    ),
    getDatastudioReport: builder.query<DatastudioReportApiProps, number>(
      datastudioReport.getEntity(),
    ),
  }),
  overrideExisting: false,
});

export const {
  useGetDatastudioReportsQuery,
  useGetDatastudioReportQuery,
} = datastudioReportApi;
